// extracted by mini-css-extract-plugin
module.exports = {"noResults":"noResults_noResults__3YgRH","promptText":"noResults_promptText__2bsBR","helperText":"noResults_helperText__bPgJP","image":"noResults_image__1QdXB"};